@if (showMarketHelp) {
    <ms-market-help [optionGroup]="optionGroup" [eventHelpText]="eventHelpText" />
}
@if (isTeamGroupingEnabled) {
    <ms-team-grouping-tab-bar [event]="event" [optionGroup]="optionGroup" (teamGroupingChange)="onTeamGroupingChange($event)" />
}
<div #groupContainer class="option-group-container player-stats-option-group">
    <div class="player-stats-option-group__players-container" [ngClass]="optionsClass()">
        <ng-container *ngTemplateOutlet="stickyColumnTemplate" />
    </div>
    <ms-scroll-adapter [scrollItems]="optionGroups()">
        <div class="player-stats-option-group__options-container">
            <ng-container *ngTemplateOutlet="scrollableColumnsTemplate" />
        </div>
    </ms-scroll-adapter>
</div>
@if (!isInSheetView) {
    <ms-option-panel-bottom-action [data]="showMoreData()" (showMore)="onShowMore($event)" (showAllRequested)="showAllRequested.next()" />
}
<ng-template #stickyColumnTemplate>
    @for (group of optionGroups(); track group.attribute || ''; let i = $index, first = $first) {
        <div class="player-stats-option-group__players" [class.hidden]="visibleOptionsLimit() ? visibleOptionsLimit()! <= i : false">
            @if (showHeaders() && first) {
                <span class="player-stats-option-group__empty"></span>
            } @else {
                @if (!isEpcotEnabled) {
                    <ms-participant-image
                        class="participant-image"
                        [participantImage]="group.participant?.image"
                        [sportId]="event.sport.id"
                        [showFallback]="true"
                        [showLogoColor]="true" />
                }
                <span class="player-stats-option-group__player-name">{{ group.attribute }}</span>
            }
        </div>
    }
</ng-template>
<ng-template #scrollableColumnsTemplate>
    @let aa = optionGroups();
    @for (group of aa; track group.attribute || ''; let i = $index, first = $first) {
        @if (showHeaders() && first) {
            <div class="player-stats-option-group__options-header">
                @for (header of headers(); track header) {
                    <span class="player-stats-option-group__header" [ngClass]="containerClass()">{{ header }}</span>
                }
            </div>
        } @else {
            <div class="player-stats-option-group__options" [class.hidden]="visibleOptionsLimit() ? visibleOptionsLimit()! <= i : false">
                <ng-container *ngTemplateOutlet="optionsTemplate; context: { $implicit: group }" />
            </div>
        }
    }
</ng-template>
<ng-template #optionsTemplate let-group>
    @for (option of group.options; track trackOption($index, option)) {
        @if (option) {
            <ms-option
                [ngClass]="containerClass()"
                [option]="option"
                [tracking]="getTrackingInfo(group.attribute)"
                [optionGroup]="optionGroup"
                [event]="event"
                [sourceOfPick]="sourcesOfPick"
                [betDetails]="betDetails"
                [showOptionAttribute]="isEpcotEnabled" />
        } @else {
            <div class="option" [ngClass]="containerClass()">
                <div class="offline option-pick">
                    <div class="value"></div>
                </div>
            </div>
        }
    }
</ng-template>
